/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lofty_Gross_Larva_WinInputs */

const es_lofty_gross_larva_win = /** @type {(inputs: Lofty_Gross_Larva_WinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu correo electrónico`)
};

const gl_lofty_gross_larva_win = /** @type {(inputs: Lofty_Gross_Larva_WinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O teu correo electrónico`)
};

const en_lofty_gross_larva_win = /** @type {(inputs: Lofty_Gross_Larva_WinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your email`)
};

/**
* | output |
* | --- |
* | "Your email" |
*
* @param {Lofty_Gross_Larva_WinInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const lofty_gross_larva_win = /** @type {((inputs?: Lofty_Gross_Larva_WinInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lofty_Gross_Larva_WinInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_lofty_gross_larva_win(inputs)
	if (locale === "en") return en_lofty_gross_larva_win(inputs)
	return es_lofty_gross_larva_win(inputs)
});